import React from 'react';
import propTypes from './propTypes';

const SeedsMoistureTracking = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 10.7979C20.4377 10.8056 23 13 23 13V23H1V13C1 13 3.56232 12.2684 9 11.4307V13.4551C6.91949 13.7804 5.29008 14.0853 4.09277 14.333C3.67663 14.4191 3.31266 14.499 3 14.5693V21H21V14.0898C20.6698 13.9151 20.2241 13.7101 19.6602 13.5156C18.5784 13.1426 17.0354 12.8001 15 12.7969V10.7979Z" fill="currentColor" />
    <path d="M10.5938 15.7217C11.3786 15.2166 12.6456 15.6039 13.4229 16.5859C14.1998 17.5679 14.193 18.7733 13.4082 19.2783C12.6233 19.7832 11.3572 19.397 10.5801 18.415C9.80284 17.433 9.80891 16.2268 10.5938 15.7217Z" fill="currentColor" />
    <path d="M16 7H13V14H11V7H8V1H16V7Z" fill="currentColor" />
    <path d="M10 3H14V5H10V3Z" fill="#F5F5F5" />
  </svg>
);

SeedsMoistureTracking.propTypes = propTypes;

export default SeedsMoistureTracking;
